import React from 'react';
import { Progress } from '@/components/ui/progress';
import { Loader2 } from 'lucide-react';

const LoadingProgress = ({ 
  isVisible, 
  message = "Aguarde, suas informações estão sendo gravadas...", 
  progress = 0,
  showProgress = true 
}) => {
  if (!isVisible) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
      <div className="bg-slate-900 border border-slate-700 rounded-lg p-8 max-w-md w-full mx-4 shadow-2xl">
        <div className="flex flex-col items-center space-y-6">
          {/* Ícone de carregamento animado */}
          <div className="relative">
            <Loader2 className="w-12 h-12 text-blue-500 animate-spin" />
            {showProgress && (
              <div className="absolute inset-0 flex items-center justify-center">
                <span className="text-sm font-semibold text-white">
                  {Math.round(progress)}%
                </span>
              </div>
            )}
          </div>

          {/* Mensagem */}
          <div className="text-center">
            <p className="text-white text-lg font-medium mb-2">
              {message}
            </p>
            {showProgress && (
              <p className="text-slate-400 text-sm">
                Processando {Math.round(progress)}% das informações...
              </p>
            )}
          </div>

          {/* Barra de progresso */}
          {showProgress && (
            <div className="w-full space-y-2">
              <Progress 
                value={progress} 
                className="h-3 bg-slate-700"
              />
              <div className="flex justify-between text-xs text-slate-400">
                <span>0%</span>
                <span className="font-medium text-white">{Math.round(progress)}%</span>
                <span>100%</span>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default LoadingProgress;
